module.exports = __webpack_public_path__ + "img/logo_symfony.30120577.png";